Object.defineProperty(exports,"__esModule",{value:true});var _platform=require('./../variables/platform');var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var thumbnailTheme={
'.square':{
borderRadius:0,
'.small':{
width:36,
height:36,
borderRadius:0},

'.large':{
width:80,
height:80,
borderRadius:0}},


'.small':{
width:36,
height:36,
borderRadius:18,
'.square':{
borderRadius:0}},


'.large':{
width:80,
height:80,
borderRadius:40,
'.square':{
borderRadius:0}},


width:56,
height:56,
borderRadius:28};


return thumbnailTheme;
};
//# sourceMappingURL=Thumbnail.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/theme/components/Thumbnail.js
// module id = 420
// module chunks = 0